export default "__VITE_ASSET__DKpa7yg1__"